<template lang="pug">
.choose-order-list
    .part-title 已选订单
        .fr(@click="$emit('back')")
            i.el-icon-arrow-left
            | 返回
    .table-list
        el-table(
            :data="tableData" size="mini" border highlight-current-row height="100%"
        )
            el-table-column(label="订单编号" prop="orderCode" min-width="80px" align="center")
            //- el-table-column(label="创建人" prop="creatorName" min-width="80px" align="center")
            el-table-column(label="素材名称" prop="contentName" min-width="80px" align="center")
            el-table-column(label="投放时间" prop="createTime" min-width="80px" align="center")
                template(slot-scope="{row}")
                    span(v-if="row.startDate && row.endDate")
                        span(v-if="row.startDate == row.endDate") {{row.startDate.replace(/-/g, '.')}}
                        span(v-else)
                            span(v-if="row.startDate.slice(0,5) == row.endDate.slice(0,5)") {{row.startDate.replace(/-/g, '.')}}-{{row.endDate.replace(/-/g, '.').slice(5)}}
                            span(v-else) {{row.startDate.replace(/-/g, '.')}}-{{row.endDate.replace(/-/g, '.')}}
            el-table-column(label="覆盖小区" prop="amount" min-width="80px" align="center")
                template(slot-scope="{row}") {{row.nbhdCount}}个
            el-table-column(label="订单状态" prop="orderStatusName" min-width="80px" align="center")
            el-table-column(label="操作" min-width="80px" align="center")
                template(slot-scope="{row}")
                    .btn(@click="winOpen(row.guid)") 查看订单
</template>

<script>
export default {
    name: "ChoosedOrder",
    props: ['data'],
    data () {
        return {
            tableData: [],
            currentRow: null
        }
    },
    watch: {
        data (data) {
            if (Object.prototype.toString.call(data) == '[object Array]') this.tableData = data
            else this.tableData = [data]
        }
    },
    async created () {
        if (Object.prototype.toString.call(this.data) == '[object Array]') this.tableData = this.data
        else this.tableData = [this.data]
    },
    methods: {
        winOpen (id) {
            window.open('/mapOrderDetail?noBack=1&id=' + id)
        }
    }
}
</script>

<style lang="sass">
.choose-order-list
    height: 100%
    .table-list
        height: calc(100% - 64px)
        .el-table
            color: #282729
</style>

<style lang="sass" scoped>
.btn
    color: #FF3973
    cursor: pointer
.part-title
    .fr
        color: #FF3973
        width: 100px
        height: 30px
        line-height: 30px
        border: 1px solid #FF3973
        border-radius: 4px
        font-size: 14px
        text-align: center
        cursor: pointer
</style>
